// This page is currently a mini-app inject within the Rails page
// In the future, this component can take over the full page load

import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import { NetworkErrorBoundary, useResource } from 'rest-hooks';
import { Provider } from 'react-redux';
import store from '../store/storeConfig';
import StoryResource from '../resources/StoryResource';
import { StoryContext } from '../hooks/useStoryContext';
import ErrorBoundary from './ErrorBoundary';
import LoadingSpinner from '../../utils/shared/LoadingSpinner';
import UserProvider from './UserProvider';
import ErrorRouter from './ErrorRouter';

export default function ShowPageWrapper({ children, storyId }) {
  const story = useResource(StoryResource.detailShape(), { id: storyId });

  return (
    <StoryContext.Provider value={story}>
      <Provider store={store}>
        <NetworkErrorBoundary fallbackComponent={ErrorRouter}>
          <Suspense fallback={<LoadingSpinner />}>
            <ErrorBoundary>
              <UserProvider>{children}</UserProvider>
            </ErrorBoundary>
          </Suspense>
        </NetworkErrorBoundary>
      </Provider>
    </StoryContext.Provider>
  );
}

ShowPageWrapper.propTypes = {
  children: PropTypes.element.isRequired,
  storyId: PropTypes.number.isRequired
};



// WEBPACK FOOTER //
// ./app/javascript/client/components/ShowPageWrapper.jsx